<template>
	<v-layout class="white" md-12 column justify-space-around style="width: 100%; max-width: 1200px; margin-bottom: 40px; margin-top: 40px;">
		<hr style="color: #BBB; margin-bottom: 30px;">
		<div class="row" style="height: 40%; justify-content: center; align-items: center; margin-bottom: 15px;">
			<h2 class="text-xs-center point7 font-weight-semibold">Thanks to Our Supporters</h2>
		</div>
		<div style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; width: 84%; margin-top: 15px; margin-left: 8%;">
			<a href="https://www.publictrust.co.nz/">
				<v-img src="./logo-pubTrust.jpg" aspect-ratio="2.046" :contain=true min-width="250" max-width="300"></v-img>
			</a>
			<a href="https://mylotto.co.nz/lottery-grants">
				<v-img src="./logo-lgb.png" aspect-ratio="2.893" :contain=true min-width="250" max-width="300"></v-img>
			</a>
		</div>
		<div style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; width: 100%; margin-top: 25px;">
			<a href="https://www.communitymatters.govt.nz/community-organisations-grants-scheme/">
				<v-img src="./logo-cogs.png" aspect-ratio="2.586" :contain=true min-width="250" max-width="300"></v-img>
			</a>
			<a href="https://www.ratafoundation.org.nz/">
				<v-img src="./logo-rata.png" aspect-ratio="4.0" :contain=true min-width="250" max-width="300"></v-img>
			</a>
			<a href="https://www.publictrust.co.nz/grants/how-do-i-find-one/grants/david-ellison-charitable-trust">
				<v-img src="./logo-dect.png" aspect-ratio="2.211" :contain=true min-width="250" max-width="300"></v-img>
			</a>
		</div>
	</v-layout>
</template>

<script>
export default {
	name: "Sponsors"
}
</script>